export function init() {
    if (document.getElementsByClassName('js-configurator-ui-modal-opener').length > 0) {
        import('./CartView').then(
            module => new module.CartView()
        );
    }
}